var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.biz)?_c('div',{staticClass:"info-body"},[_c('InfoBox')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }